module.exports = __webpack_public_path__ + "static/media/bamba.84000a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/bamba.jpg
// module id = 731
// module chunks = 0